import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    logueado: '',
    userLogin: {},
    direccionSelect: '',
    direccionObj: '',
    tanqueActualSel: {},
    tanqueIsEditing: false,
    verificacionActual: {},
    autotanques: [],
    verificadosCompletos: '',
    numEmplazados: 0,
    tanqueSalida: {},
    itemAgregado: '',
    actCompAutocomplete: '',
    actListadoItemsSalida: '',
    actListadoAsignados: '',
    articulos_Salida: [],
    area_soporte: '',
    area_solicitud: '',
    estacionSel: '',
    tipoSalida: '',
    almacenSelect: '',
    consumibleSelected: {},
    accesoFirma: '',
    realizoFirma: false,
    requisicion_firma: {},
    estadoReq: 0,
    articulosReasignar: [],
    irgeEditarEmb: {},
    responsiva_firma: {},
    responsiva_editar: {},
    salida_firmar: {},
    asignacion_firmar: {},
    prestamo_firmar: {},
    salida_detalle: {},
    asignacion_detalle: {},
    prestamo_detalle: {},
    combustible_Reporte_firmar: {},
    combustible_salidaSelect: {},
    salida_consu_firmar: {},
    proveedorEdit: {},
    requisicionEdit: {},
    cotizacionEdit: {},
    ticketAtendido: {},
    areaAsignacion: '',
    irgeAccesoEditar: [],
    tpaAccesoEditar: [],
    corpoVisita: {},
    origenCorpoVisita: 0,
    isArticuloEspecial: false,
    articuloBaja: '',
    baja_firmar: {},
    permisos: {},
    editarEmb_IRGE: {},
    editarEmb_TPA: {},
    idEditarSubgrupo:{},
    idCompaniaSelected:{},
    idGrupoSelected:{},
    nomGrupoSelected:{},
    nomCompaniaSelect:{},
    carpertas_anios: [],
    carpertas_anios_select: [],
    bts: [],
    bts_select: {},
    archivos: [],
    archivo_select: {},
    archivosEDA: [],
  },
  mutations: {
    setlogin (state, logueado) {
      state.logueado = logueado
    },
    usuarioLogueado (state, usuario) {
      state.userLogin = usuario
    },
    direccionActual (state, id) {
      state.direccionSelect = id
    },
    direccionActualCompleta (state, direccion) {
      state.direccionObj = direccion
    },
    
    itemAdd (state, agregado) {
      state.itemAgregado = agregado
    },
    actComp_Autocomplete (state, status) {
      state.actCompAutocomplete = status
    },
    actList_ItemSalida (state, status) {
      state.actListadoItemsSalida = status
    },
    actList_Asignados (state, status) {
      state.actListadoAsignados = status
    },

    agregarArticulos_Salida (state, articulo) {
      state.articulos_Salida.push(articulo)
    },
    quitarArticulo_Salida (state, articulo) {
      var indexOfArt = state.articulos_Salida.findIndex(i => i.id === articulo.id)
      state.articulos_Salida.splice(indexOfArt,1)
    },
    limpiarArticulos_Salida (state) {
      state.articulos_Salida.length = 0
    },

    tanqueActual (state, tanque) {
      state.tanqueActualSel = tanque
    },

    tanqueIsEditing (state, accion) {
      if (accion) {
        state.tanqueIsEditing = true
      } else {
        state.tanqueIsEditing = false
      }
    },

    addTanque (state, tanque) {
      state.autotanques.push(tanque)
    },

    selectSalida (state, tipoSalida) {
      state.tipoSalida = tipoSalida
    },

    selectAlmacen (state, almacen) {
      state.almacenSelect = almacen
    },

    resetTanques (state) {
      state.autotanques.length = 0
    },
    verificarTanque (state, idTanque) {
      state.autotanques.forEach(element => {
        if (element.id === idTanque) {
          element.verificado = true
          console.log('pg VERIFICADO')
        } else {
          console.log('No es el mismo PG')
        }
      })
    },

    verificacionActual (state, verificacion) {
      state.verificacionActual = verificacion
    },

    verificacionComplete (state, completa) {
      state.verificadosCompletos = completa
    },
    
    emplazadosCount (state, idTanque) {
      state.autotanques.forEach(element => {
        if (element.id === idTanque) {
          element.emplazado = true
          console.log('pg VERIFICADO')
        } else {
          element.emplazado = false
          console.log('No es el mismo PG')
        }
      })
    },

    autotanqueSalida (state, tanque) {
      state.tanqueSalida = tanque
    },
    irSoporte (state, area) {
      state.area_soporte = area
    },
    irSolicitud (state, area) {
      state.area_solicitud = area
    },
    irEstaciones (state, estation) {
      state.estacionSel = estation
    },
    selectConsumible (state, consumible) {
      state.consumibleSelected = consumible
    },
    firmaPuntos (state, idVerificacion) {
      state.accesoFirma = idVerificacion
    },
    firmando (state, estuvo) {
      state.realizoFirma = estuvo
    },
    firmaRequisicion (state, requisicion) {
      state.requisicion_firma = requisicion
    },
    estadoRequisicion (state, estado) {
      state.estadoReq = estado
    },
    listaReasignar (state, list) {
      state.articulosReasignar = list
    },
    quitarArticulo_Asignacion (state, articulo) {
      var indexOfArt = state.articulosReasignar.findIndex(i => i.id === articulo.id)
      state.articulosReasignar.splice(indexOfArt,1)
    },
    editarEmb_IRGE (state, embarque) {
      state.editarEmb_IRGE = embarque
    },
    editarEmb_TPA (state, embarque) {
      state.editarEmb_TPA = embarque
    },
    firmarResponsiva (state, responsiva) {
      state.responsiva_firma = responsiva
    },
    editarResponsiva (state, responsiva) {
      state.responsiva_editar = responsiva
    },
    firmarSalida (state, salida) {
      state.salida_firmar = salida
    },
    firmarSalidaConsumible (state, consumible) {
      state.salida_consu_firmar = consumible
    },
    firmarAsignacion (state, asignacion) {
      state.asignacion_firmar = asignacion
    },
    firmarPrestamo (state, prestamo) {
      state.prestamo_firmar = prestamo
    },
    detalleSalida (state, salida) {
      state.salida_detalle = salida
    },
    detalleAsignacion (state, asignacion) {
      state.asignacion_detalle = asignacion
    },
    detallePrestamo (state, prestamo) {
      state.prestamo_detalle = prestamo
    },
    firmarReporte (state, reporte) {
      state.combustible_Reporte_firmar = reporte
    },
    seleccionarSalidaComb (state, salida) {
      state.combustible_salidaSelect = salida
    },
    editarProveedor (state, proveedor) {
      state.proveedorEdit = proveedor
    },
    editarRequisicion (state, requisicion) {
      state.requisicionEdit = requisicion
    },
    editarCotizacion (state, cotizacion) {
      state.cotizacionEdit = cotizacion
    },
    atenderTicket (state, ticket) {
      state.ticketAtendido = ticket
    },
    showAreaAsignacion (state, area) {
      state.areaAsignacion = area
    },
    editarAccesoIrge (state, acceso) {
      state.irgeAccesoEditar = acceso
    },
    editarAccesoTpa (state, acceso) {
      state.tpaAccesoEditar = acceso
    },
    registrarVisitaCorpo (state, visita) {
      state.corpoVisita = visita
    },
    origenCorpoVisita (state, visita) {
      state.origenCorpoVisita = visita
    },
    esArticuloEspecial (state, especial) {
      state.isArticuloEspecial = especial
    },
    bajaArticulo (state, id) {
      state.articuloBaja = id
    },
    firmarBaja (state, baja) {
      state.baja_firmar = baja
    },
    setPermisos(state, permisos) {
      state.permisos = permisos
    },
    idEditarSubgrupo(state, id) {
      state.idEditarSubgrupo = id
    },
    idCompaniaSelected (state, id){
      state.idCompaniaSelected = id
    },
    idGrupoSelected(state, id){
      state.idGrupoSelected = id
    },
    nomGrupoSelected (state, nombre){
      state.nomGrupoSelected = nombre
    },
    nomCompaniaSelect (state, nombre){
      state.nomCompaniaSelect = nombre
    },

    setCarpetasAnios(state, carpetas_anios) {
      state.carpertas_anios = carpetas_anios
    },

    insertCarpetaAnio (state, carpeta_anio) {
      state.carpertas_anios.push(carpeta_anio)
    },

    selectCarpetaAnio (state, carpeta_anio) {
      state.carpertas_anios_select = carpeta_anio
    },

    setBTS(state, bts) {
      state.bts = bts
    },

    selectBts(state, bts) {
      state.bts_select = bts
    },

    insertBts(state, bt) {
      console.log("🚀 ~ file: store.js:317 ~ insertBts ~ bt", bt)
      state.bts.push(bt)
    },

    setArchivos(state, archivos) {
      state.archivos = archivos
    },
    
    selectArchivo(state, archivo) {
      state.archivo_select = archivo
    },
    
    insertArchivo(state, archivo) {
      state.archivos.push(archivo)
    },

    
    deleteArchivo(state, archivo) {
      console.log("🚀 ~ file: store.js:337 ~ deleteArchivo ~ archivo", archivo)
      state.archivos = state.archivos.filter( f => f.id !== archivo.id)
    },
    
    setArchivosEDA(state, archivosEDA) {
      state.archivosEDA = archivosEDA
    },
    
    insertArchivoEDA(state, archivo) {
      state.archivosEDA.push(archivo)
    },
    
    deleteArchivoEDA(state, archivo) {
      state.archivosEDA = state.archivosEDA.filter( f => f.id !== archivo.id)
    },
  }
})

export default store




// WEBPACK FOOTER //
// ./src/store.js